<div *ngIf="notification" class="push-notification" (click)="navigateToVideo()">
    <img src="{{notification.image}}" />
    <div class="inner">
        <h4>{{notification.title}}</h4>
        <p class="mb-0">{{notification.body}}</p>
    </div>
</div>